import React from 'react';

export type DirectionContextType = 'rtl' | 'ltr';

export const DirectionContext = React.createContext<DirectionContextType>('ltr');
